{
  "list": {
    "title": "Students",
    "addStudent": "Add Student",
    "searchLabel": "Search",
    "searchPlaceholder": "Search by name or email…",
    "allStatuses": "All statuses",
    "cols": {
      "name": "Name",
      "email": "Email",
      "status": "Status",
      "tags": "Tags"
    },
    "countOne": "{count} student",
    "countOther": "{count} students",
    "prev": "Prev",
    "next": "Next",
    "pageOf": "Page {page} of {pages}"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "create": {
    "sharePrompt": "Student created and set active. Share this onboarding link so they can accept the terms and set a password:",
    "onboardingLinkAria": "Onboarding link",
    "copy": "Copy",
    "singleUseHint": "The link is single-use and expires once onboarding is complete.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "setActive": "Set active immediately",
    "activeHint": "Active students can sign in to the portal right away. The onboarding link will be shown here after creating.",
    "done": "Done",
    "create": "Create",
    "required": "First name, last name, and email are required"
  },
  "toast": {
    "created": "Student created",
    "createFailed": "Failed to create student",
    "linkCopied": "Link copied",
    "copyFailed": "Copy failed — select the link manually",
    "linkRegenerated": "Onboarding link regenerated",
    "tierUpdated": "Price tier updated",
    "invalidOverride": "Enter a non-negative amount, or leave blank to clear",
    "overrideCleared": "Override cleared",
    "overrideSaved": "Override saved",
    "paymentsGenerated": "{count} payment(s) generated",
    "chooseMethod": "Choose a payment method",
    "paymentRecorded": "Payment recorded",
    "invalidCredit": "Enter a positive credit amount",
    "creditIssued": "Credit issued",
    "levelUpdated": "Level updated",
    "enrolled": "Enrolled"
  },
  "tabs": {
    "profile": "Profile",
    "classes": "Classes",
    "levels": "Levels",
    "payments": "Payments",
    "attendance": "Attendance"
  },
  "detail": {
    "deactivate": "Deactivate",
    "activate": "Activate",
    "resetPassword": "Reset password",
    "addTagPlaceholder": "Add tag…",
    "onboardingLink": "Onboarding link:",
    "gdpr": {
      "title": "Data & privacy (GDPR)",
      "lede": "Export this student's complete data on request, or erase their personal data while retaining the financial records the law requires.",
      "badge": "Anonymized",
      "export": "Export data",
      "exporting": "Preparing…",
      "exportStarted": "Export downloaded",
      "erase": "Erase personal data",
      "erasing": "Erasing…",
      "erased": "Personal data erased",
      "alreadyErased": "Personal data was erased on {date}.",
      "eraseTitle": "Erase personal data",
      "eraseWarning": "This permanently anonymizes {name}. It cannot be undone.",
      "bulletAnonymize": "Name, contact details, and all personal fields are wiped; the account is deactivated.",
      "bulletMedia": "Uploaded media (profile photo, gallery items) is deleted from storage.",
      "bulletFinancials": "Payment and accounting records are kept, but linked to an anonymized identity.",
      "confirmLabel": "Type DELETE to confirm",
      "eraseConfirmBtn": "Erase data"
    },
    "fields": {
      "email": "Email",
      "phone": "Phone",
      "dob": "Date of birth",
      "gender": "Gender",
      "address": "Address",
      "guardian": "Guardian",
      "statusNotes": "Status notes",
      "contractAccepted": "Contract accepted"
    },
    "yes": "Yes",
    "no": "No",
    "classes": {
      "enrollLabel": "Enroll in class",
      "selectPlaceholder": "Select a class…",
      "enroll": "Enroll",
      "colClass": "Class",
      "colTeacher": "Teacher",
      "colDay": "Day",
      "colTime": "Time",
      "empty": "Not enrolled in any classes"
    },
    "levels": {
      "levelLabel": "Level",
      "levelPlaceholder": "Level…",
      "danceTypeLabel": "Dance type",
      "danceTypePlaceholder": "Type…",
      "assignUpdate": "Assign / Update",
      "empty": "No levels assigned yet"
    },
    "payments": {
      "pricingFees": "Pricing & fees",
      "priceTier": "Price tier",
      "assignFee": "Assign a fee",
      "chooseFee": "Choose a fee…",
      "colFee": "Fee",
      "colType": "Type",
      "colAmount": "Amount",
      "overrideTag": "(override)",
      "override": "Override",
      "remove": "Remove",
      "noFees": "No fees assigned",
      "generateMonth": "Generate this month",
      "colDue": "Due",
      "colMethod": "Method",
      "colStatus": "Status",
      "creditTag": "({amount} credit)",
      "noPaymentsHeading": "No payments yet",
      "noPaymentsMessage": "Assign a fee, then generate this month’s payments.",
      "record": "Record"
    },
    "credit": {
      "title": "Credit",
      "balanceLabel": "Balance:",
      "autoApplied": "auto-applied when payments are recorded.",
      "hideDetails": "Hide details",
      "showDetails": "Show details",
      "colDate": "Date",
      "colActivity": "Activity",
      "colDetail": "Detail",
      "colAmount": "Amount",
      "added": "Added",
      "used": "Used",
      "issueLabel": "Issue credit",
      "amountPlaceholder": "Amount",
      "noteLabel": "Note",
      "notePlaceholder": "e.g. refund, goodwill",
      "addCredit": "Add credit",
      "paymentDefault": "Payment"
    },
    "attendance": {
      "colDate": "Date",
      "colClass": "Class",
      "colStatus": "Status",
      "empty": "No attendance records yet"
    },
    "override": {
      "customPrice": "Custom price for",
      "default": "· default {amount}",
      "amountLabel": "Override amount ({currency})",
      "amountPlaceholder": "blank = use tier price",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "e.g. hardship rate",
      "clearHint": "Leave the amount blank and save to remove the override and revert to the tier-resolved price."
    },
    "record": {
      "title": "Record payment",
      "creditWillApply": "({amount} credit will apply)",
      "paidVia": "Paid via",
      "methodDefault": "{name} (default)",
      "referenceLabel": "Reference (optional)",
      "referencePlaceholder": "e.g. transfer ref / receipt no.",
      "notesLabel": "Notes (optional)",
      "noMethods": "No enabled payment methods — add one in Settings → Billing."
    }
  }
}
